import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const TimeWrap = styled.div`
  font-size: 30px;
  color: #fff;
`;

const Time = styled.span`
  font-size: 30px;
  color: #fff;
`;

export const VideoPlayerTime = () => {
  const state = useSelector((state) => state);

  return (
    <TimeWrap>
      <Time>{state.video.current_time}</Time>
      &nbsp;/&nbsp;
      <Time>{state.video.duration_time}</Time>
    </TimeWrap>
  );
};